import { useVideoPlayerDuration } from "../hooks/use-video-player-helpers";

export function TimeDisplay() {
  const { formattedCurrentTime, formattedDuration } = useVideoPlayerDuration();
  return (
    <span className="video-player-2-time">
      {formattedCurrentTime} / {formattedDuration}
    </span>
  );
}
